goog.provide("shadow.js.shim.module$src$svg$wpp$content$iframe_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$iframe_svg");
shadow.js.shim.module$src$svg$wpp$content$iframe_svg = shadow.js.nativeProvides["src/svg/wpp/content/iframe.svg"] = shadow$bridge("src/svg/wpp/content/iframe.svg");
module$shadow_js_shim_module$src$svg$wpp$content$iframe_svg.default = shadow.js.shim.module$src$svg$wpp$content$iframe_svg;
